import { render, staticRenderFns } from "./CompetitionSearchField.vue?vue&type=template&id=59b8e99d&scoped=true"
import script from "./CompetitionSearchField.vue?vue&type=script&lang=ts"
export * from "./CompetitionSearchField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8e99d",
  null
  
)

export default component.exports